import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';
import { MarkierungType } from '@/domain/termine/shared/types/Markierung';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { TerminImage } from '@/domain/termine/shared/types/TerminImage';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';

export class Termin {
  beginn?: string;
  datum: string;
  ende?: string;
  id: string;
  repetitionId?: string;
  standortId: string;
  idTerminkalender?: string;
  image?: TerminImage;
  markierung: MarkierungType;
  titel: string;
  wiederholung: TerminWiederholung;
  wiederholungBis?: string;
  beschreibung?: string;
  specials?: string;
  arbeitszeiten?: Arbeitszeit[];
  schichten?: Schichten[];
  hasHiddenArbeitszeiten?: boolean;
  hasHiddenSchichten?: boolean;

  constructor(data: {
    beginn?: string;
    datum: string;
    ende?: string;
    id: string;
    repetitionId?: string;
    standortId: string;
    idTerminkalender?: string;
    image?: TerminImage;
    markierung: MarkierungType;
    titel: string;
    wiederholung: TerminWiederholung;
    wiederholungBis?: string;
    beschreibung?: string;
    specials?: string;
    arbeitszeiten?: Arbeitszeit[];
    schichten?: Schichten[];
    hasHiddenArbeitszeiten?: boolean;
    hasHiddenSchichten?: boolean;
  }) {
    this.beginn = data.beginn;
    this.datum = data.datum;
    this.ende = data.ende;
    this.id = data.id;
    this.repetitionId = data.repetitionId;
    this.standortId = data.standortId;
    this.idTerminkalender = data.idTerminkalender;
    this.image = data.image;
    this.markierung = data.markierung;
    this.titel = data.titel;
    this.wiederholung = data.wiederholung;
    this.wiederholungBis = data.wiederholungBis;
    this.beschreibung = data.beschreibung;
    this.specials = data.specials;
    this.arbeitszeiten = data.arbeitszeiten ?? [];
    this.schichten = data.schichten ?? [];
    this.hasHiddenSchichten = data.hasHiddenSchichten;
    this.hasHiddenArbeitszeiten = data.hasHiddenArbeitszeiten;
  }
}
